import Social from './Social'

export default Social
